var $scriptTag = $('<script>', { src: 'https://www.youtube.com/iframe_api' });
$('script:first').before($scriptTag);

var players = [];
var $playerElementsControls = $('[data-type="youtube"][data-video="controls"] .video-container div');
var $playerElementsAutoplay = $('[data-type="youtube"][data-video="autoplay"] .video-container div');



// Define the YouTube API callback globally
window.onYouTubeIframeAPIReady = function () {
	// console.log('onYouTubeIframeAPIReady');

	$playerElementsControls.each(function () {
		var $element = $(this);
		var videoId = $element.data('video-id'); // Use jQuery's .data() for data attributes
		var containerId = $element.data('id'); // Use jQuery's .data() for data attributes

		console.log($element);

		var player = new YT.Player(this, {
			height: '9',
			width: '16',
			videoId: videoId,
			playerVars: {
				'playsinline': 1,    // Plays the video inline on iOS devices
				'controls': 0,       // Hides all controls
				'modestbranding': 1, // Removes YouTube branding
				'disablekb': 1,      // Disables keyboard controls
				'rel': 0,            // Prevents related videos
			},
			host: 'https://www.youtube-nocookie.com',
			events: {
				'onReady': function () {
					attachClickHandler(containerId, player);
				},
				// 'onStateChange': onPlayerStateChange,
				'onStateChange': function(event) {
					onPlayerStateChange(event, player, containerId);
				}
			}
		});

		players.push(player);
	});

	$playerElementsAutoplay.each(function () {
		var $element = $(this);
		var videoId = $element.data('video-id'); // Use jQuery's .data() for data attributes
		var containerId = $element.data('id'); // Use jQuery's .data() for data attributes

		console.log($element);

		var player = new YT.Player(this, {
			height: '9',
			width: '16',
			videoId: videoId,
			playerVars: {
				'playsinline': 1,    // Plays the video inline on iOS devices
				'controls': 0,       // Hides all controls
				'modestbranding': 1, // Removes YouTube branding
				'disablekb': 1,      // Disables keyboard controls
				'rel': 0,            // Prevents related videos
				'autoplay': 1,            // Prevents related videos
				'mute': 1,            // Prevents related videos
			},
			host: 'https://www.youtube-nocookie.com',
			events: {
				'onReady': function () {
					attachClickHandler(containerId, player);
				},
				// 'onStateChange': onPlayerStateChange,
				'onStateChange': function(event) {
					onPlayerStateChange(event, player, containerId);
				}
			}
		});

		players.push(player);
	});
};

function attachClickHandler(containerId, player) {
	var section = $('.video-container[data-id="' + containerId + '"]').closest('section');
	var playBtn = section.find('.video-play');
	var pauseBtn = section.find('.video-pause');
    var muteBtn = section.find('.video-mute');
    var unmuteBtn = section.find('.video-unmute');
	var text = section.find('.video-content');

	var pauseBtnTab = $('section[data-section="videoType2"] [data-tab-trigger]');
	if (pauseBtnTab.length) {
		pauseBtnTab.on('click', function () {
			console.log('stop');
			player.pauseVideo(); // Play video when the image container is clicked
			playBtn.attr('data-visible','true');
			pauseBtn.attr('data-visible','false');
		});
	}

	if (playBtn.length) {
		playBtn.on('click', function () {
			console.log('play');
			player.playVideo(); // Play video when the image container is clicked
			playBtn.attr('data-visible','false');
			pauseBtn.attr('data-visible','true');
			if ($(window).width() < 1024) {
				text.slideUp();
			}
		});
	}
	if (pauseBtn.length) {
		pauseBtn.on('click', function () {
			console.log('stop');
			player.pauseVideo(); // Play video when the image container is clicked
			playBtn.attr('data-visible','true');
			pauseBtn.attr('data-visible','false');
			if ($(window).width() < 1024) {
				text.slideDown();
			}
		});
	}
    if (muteBtn.length) {
        muteBtn.on('click', function () {
            console.log('mute');
            player.mute();
            muteBtn.attr('data-visible', 'false');
            unmuteBtn.attr('data-visible', 'true');
        });
    }
    if (unmuteBtn.length) {
        unmuteBtn.on('click', function () {
            console.log('unmute');
            player.unMute();
            muteBtn.attr('data-visible', 'true');
            unmuteBtn.attr('data-visible', 'false');
        });
    }
}

function updateProgressBar(containerId, player) {
    var section = $('.video-container[data-id="' + containerId + '"]').closest('section');
	var progressBar = section.find('.video-progress .bar');
    var currentTime = player.getCurrentTime(); // Current time of the video
    var duration = player.getDuration(); // Total duration of the video

    var progressPercentage = (currentTime / duration) * 100; // Calculate the percentage of video played
    progressBar.css('width', progressPercentage + '%'); // Update the progress bar width
}

function onPlayerStateChange(event, player, containerId) {
	var section = $('.video-container[data-id="' + containerId + '"]').closest('section');
	var img = section.find('.image-container');
	var progressBar = section.find('.video-progress .bar');
	var playBtn = section.find('.video-play');
	var pauseBtn = section.find('.video-pause');
	if (event.data === YT.PlayerState.PLAYING) {
		console.log('Video is playing:', event.target.getIframe().id);
		console.log($('#' + event.target.getIframe().id).parent());
		img.hide();
		player.progressInterval = setInterval(function() {
			updateProgressBar(containerId, player);
		}, 50);
	}
	if (event.data === YT.PlayerState.ENDED) {
		console.log('Video ended:', event.target.getIframe().id);
		clearInterval(player.progressInterval);
		img.show();
		progressBar.css('width', '0%');
		playBtn.attr('data-visible','true');
		pauseBtn.attr('data-visible','false');
	}
}